import { MARGIN_TYPES, ASSET_SYMBOL } from 'constants/constants';
import type { MarginFloorTypes } from 'types/IAsset';
import { ContractType, Product } from 'types/IProducts';

export interface EnabledPFs {
  [key: string]: MarginFloorTypes;
}

interface getWarningMsgProps {
  marginMode: string;
  selectedProduct: Product;
  enabledPfs: EnabledPFs;
}
export const getWarningMessage = ({
  marginMode,
  selectedProduct,
  enabledPfs,
}: getWarningMsgProps) => {
  const {
    settling_asset: settlingAsset,
    spot_index: spotIndex,
    contract_type: contractType,
  } = selectedProduct;
  let msgCode = '';

  switch (contractType) {
    case ContractType.Futures:
    case ContractType.PerpetualFutures:
    case ContractType.CallOptions:
    case ContractType.PutOptions:
      if (marginMode === MARGIN_TYPES.PORTFOLIO) {
        if (settlingAsset?.symbol === ASSET_SYMBOL && !enabledPfs?.[spotIndex?.symbol!]) {
          msgCode = 'pf_disabled';
        } else if (settlingAsset?.symbol !== ASSET_SYMBOL) {
          msgCode = 'only_isolated';
        }
      }

      if (marginMode === MARGIN_TYPES.CROSS && settlingAsset?.symbol !== ASSET_SYMBOL) {
        msgCode = 'only_isolated';
      }
      break;
    case ContractType.OptionsCombos:
      if (marginMode === MARGIN_TYPES.PORTFOLIO) {
        msgCode = 'pf_disabled';
      }
      break;
    case ContractType.Tracker:
      if (marginMode === MARGIN_TYPES.PORTFOLIO) {
        msgCode = 'pf_disabled';
      }
      if (marginMode === MARGIN_TYPES.CROSS) {
        msgCode = 'only_isolated';
      }
      break;
    default:
      break;
  }

  return msgCode;
};
